import React from "react";
import { PieChart } from "react-minimal-pie-chart";
import PropTypes from "prop-types";

import styles from "../../config/styles";

const DashboardChart = ({ className, title, amount }) => {
  let value;
  let remainingValue;
  if (amount) {
    value = parseInt(amount.split("%")[0], 10);
    remainingValue = 100 - value;
  }

  return (
    <div className={`chart ${className}`}>
      <p className="chart-header">
        {title}
        {":\r"}
      </p>
      <div className="pie-chart">
        <PieChart
          animate
          animationDuration={2000}
          animationEasing="ease-out"
          lineWidth={15}
          rounded
          data={[
            {
              title: "Uncompleted",
              value: remainingValue,
              color: "#e5e5e5",
            },
            {
              title: "Completed",
              value,
              color: styles.primaryColor,
            },
          ]}
        />
        <div className="pie-chart-amount">
          <h1>{amount}</h1>
        </div>
      </div>
    </div>
  );
};

DashboardChart.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  amount: PropTypes.string,
};

DashboardChart.defaultProps = {
  className: "",
  title: "",
  amount: "0%",
};

export default DashboardChart;
